import { useTranslation } from "src/context/Translations/context";
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { convertIFileDTOArrayToFileArray } from "src/Interfaces/fileDTO";
import ModalAttachments from "src/components/ModalAttachments";
import { standardErrorMessages } from "src/utils/errors";
import { IMatba004 } from "../interface";

export interface IRefModalAttachmentsAnalysis{
	openAttachments: (row: IMatba004, labelLevel3: string, view: boolean, onCallbackFunction?: Function) => void;
  }

const ModalAttachmentsAnalysis : React.ForwardRefRenderFunction<IRefModalAttachmentsAnalysis> = (_, ref) => {

	const { translate } = useTranslation();
	const refModalAttachment = useRef<RCCRefModalProps>(null);
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();

	const [level3Id, setlevel3Id] = useState<number>(0);
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [attachments, setAttachments] = useState<File[]>([]);
	const [disabled, setDisabled] = useState(false);
	const onCallbackFunction = useRef<Function | undefined>(undefined);

	useImperativeHandle(ref, () => ({
		openAttachments
	}));

	const openAttachments = (level3: IMatba004, labelLevel3: string, view: boolean, callbackChange?: Function) => {
		onCallbackFunction.current  = callbackChange;
		setDisabled(view);
		setSubtitle(`${labelLevel3}: ${level3.maa004Descricao}`);
		setlevel3Id(level3.maa004Id);
		queryAttachments(level3.maa004Id);
	};

	const queryAttachments= async (id: number) => {
		try{
			setLoading(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "Analysis/SelectAttachmentsLevel3",
				urlParameters: {
					id
				}
			});
			let dataFormatted: File[] = [];

			if(data && data.length > 0)
				dataFormatted = convertIFileDTOArrayToFileArray(data);

			setAttachments(dataFormatted);
			setLoading(false);

			refModalAttachment.current?.openModal();
		}catch(err){
			setLoading(false);
		}
	};
  
	const onAddAttachment = useCallback(async (data: any) => {
		try{
			setLoading(true);
			const formData = new FormData();

			formData.append("level3Id", level3Id.toString());
      
			data.attachments.forEach((attach: any, index: number) => {
				formData.append(`Attachments[${index}]`, attach);
			});

			await RCCServicesApi.postRequest({
				method: "Analysis/InsertAttachmentsLevel3",
				contentType: "multipart/form-data",
				body: formData
			});

			addToast({
				title: translate("Sucesso"),
				description: translate("Anexo inserido com sucesso"),
				color: "green"
			});

			onCallbackFunction.current?.();

			refModalAttachment.current?.closeModal();
				
			setLoading(false);

		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao adicionar anexos"), addToast);
		}
	}, [level3Id]);

	return (
		<>
      	<ModalAttachments 
				ref={refModalAttachment}
				subtitle={subtitle}
				filesInit={attachments}
				name="attachments"
				onSubmit={onAddAttachment}
				disabled={disabled}
				showSaveButton={!disabled}
			  />
		</>
	);
};

export default forwardRef(ModalAttachmentsAnalysis);
